<template>
  <div class="flex flex-col h-full px-6 w-full">
    <div class="flex border border-bnb-mustard2 p-4 py-3 rounded-md">
      <img alt="image" class="h-6 opacity-50" src="@/assets/icons/search.svg" />
      <input
        v-model="searchQuery"
        :onsearch="search"
        type="search"
        class="flex-1"
        placeholder="Enter Order Reference"
      />
    </div>
    <div v-if="searching" class="flex-1 flex items-center">
      <p class="mx-auto">
        <img
          alt="image"
          class="h-20 w-20 animate-spin"
          src="@/assets/logosquare.png"
        />Searching...
      </p>
    </div>
    <div v-else-if="result" class="py-4">
      <OrderItem :order="result" />
    </div>
  </div>
</template>
<script>
import firebase from "firebase/app";
import OrderItem from "@/views/orders/OrderItem.vue";
export default {
  components: { OrderItem },
  data() {
    return {
      searching: false,
      searchQuery: "",
      result: "",
    };
  },
  methods: {
    search() {
      this.searching = true;
      this.result = "";
      firebase
        .firestore()
        .collection("Orders")
        .where("orderReference", "==", this.searchQuery.toUpperCase())
        .get()
        .then((snapshot) => {
          this.searching = false;
          this.result = snapshot.docs[0]?.data() ?? "";
        })
        .catch(() => {
          this.searching = false;
        });
      return true;
    },
  },
};
</script>
